import { createRevealContext } from './context'

// Per-template reveal registry, keyed by template name (ctx.template).
// Add an entry per page template, e.g.:
//   import home from './templates/home'
//   const templates = { home }
// Each value is an object of entry handlers: { direct, swup, history, default }.
const templates = {}

/**
 * Run page reveal for current template + entry type
 *
 * @param {'direct'|'swup'|'history'} entry
 * @returns {gsap.core.Timeline|null|void}
 */
export function revealPage(entry) {
	const ctx = createRevealContext()
	const templateName = ctx.template
	if (!templateName) return

	const template = templates[templateName]
	if (!template) return
	// resolve reveal: entry-specific or fallback
	const reveal = template[entry] || template.default

	if (!reveal) return

	return reveal(ctx)
}
